import { InjectionToken } from '@angular/core';

import { DictionariesApi } from './dictionaries-api.interface';

export const DICTIONARIES_API = new InjectionToken<DictionariesApi>('DICTIONARIES_API');
